// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1szSl","footer":"ChangeClinic_footer__e-J4u"};